import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";

export const useDrivers = () => {
  return useQuery({
    queryKey: ["drivers"],
    queryFn: () => apiClient.getDrivers(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useDriver = (id: string) => {
  return useQuery({
    queryKey: ["driver", id],
    queryFn: () => apiClient.getDriver(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
